import PropTypes from 'prop-types';

export const contentDeploymentWarningModalTypes = {
  name: PropTypes.string,
  status: PropTypes.string,
};
